export default __webpack_public_path__ + "static/media/empty.877de33f.svg";